import { format } from "date-fns";
import EventModal from "./EventModal";
import { PlanningEvent } from "./PlanningEvent";
import { isAfterParsedDate } from "./Planning3";

export const PlanningDayView = ({
  events,
  timeSlots,
  handleClick,
  handleOpenModal,
  handleCloseModal,
  open,
  highligtedEvent,
  day_view,
  daysOfWeek,
  weekDates,
  height,
  events_colors,
  pack_short_dict,
  simplified_view,
  masterData,
  orgData,
  userData,
  selected_operators,
  onDelete,
  navigateWorkspace,
  workspaceData,
  getYPosition,
  timeToMinutes,
  operators,
}) => {
  return (
    <>
      {day_view != null &&
        daysOfWeek
          .filter((day, index) => index === day_view)
          .map((day, day_index) => (
            <div
              key={day_view}
              className="bg-transparent rounded-lg  w-full select-none flex flex-col  font-light min-h-fit p-1 text-h4 text-black justify-center"
              style={{
                height: `${height}px`,
              }}
            >
              <div className="flex flex-row gap-1 w-full h-full">
                {operators
                  .filter((operator) =>
                    selected_operators.includes("no_operator")
                      ? false
                      : selected_operators.includes(operator?.id) ||
                        selected_operators.includes("all")
                  )
                  .map((operator, index) => (
                    <div key={index} className="flex flex-col  w-full h-full ">
                      <div
                        key={index}
                        className=" gap-1 w-full h-c500 relative  "
                        style={{
                          height: `${height}px`,
                        }}
                      >
                        <div
                          className="absolute w-full max-h-full "
                          style={{
                            top: "6px",
                          }}
                        >
                          {timeSlots.map((hour, index) => (
                            <div
                              key={hour + index.toString()}
                              style={{
                                height: `${height * 0.0772}px`,
                              }}
                              onClick={(e) => {
                                handleClick(e, day_view, operator?.id, hour);
                              }}
                              className=" w-full border-t-2 border-x-2 border-wshadow_25  rounded-lg select-none relative flex-col hover:border-2 hover:border-wshadow_50 hover:bg-shadow_3 font-light p-2 justify-start"
                            ></div>
                          ))}{" "}
                        </div>
                        {events
                          .filter(
                            (event) =>
                              (event.weekdate === day &&
                                event.frequency !== "daily") ||
                              event.frequency === "daily"
                          )
                          .filter((event) =>
                            event.exception_dates
                              ? !(event.exception_dates || []).includes(
                                  format(weekDates[day_view], "dd/MM/yyyy")
                                )
                              : event.upper_limit_date &&
                                  isAfterParsedDate(
                                    format(weekDates[day_view], "dd/MM/yyyy"),
                                    event.upper_limit_date
                                  )
                                ? false
                                : true
                          )
                          .filter((event) =>
                            event.members_id && event.members_id.length > 0
                              ? event.members_id.includes(operator?.id)
                              : false
                          )
                          .sort((a, b) => a.start - b.start)

                          .map((event, index) => {
                            return (
                              <div
                                key={index}
                                className="absolute w-full "
                                style={{
                                  top: `${getYPosition(timeToMinutes(event.startTime))}rem`,
                                }}
                              >
                                <EventModal
                                  parsed_date={format(
                                    weekDates[day_index],
                                    "dd/MM/yyyy"
                                  )}
                                  event={event}
                                  setEvent={() => {}}
                                  setModalOpen={() =>
                                    handleCloseModal(event.id)
                                  } // Pass close modal handler
                                  orgData={orgData}
                                  userData={userData}
                                  onDelete={(e) => {
                                    onDelete(e);
                                  }}
                                  onUpdate={() => {}}
                                  open={open[event.id]}
                                  setOpen={(e) => {
                                    handleOpenModal(event.id);
                                  }}
                                  navigateWorkspace={navigateWorkspace}
                                  workspaceData={workspaceData}
                                >
                                  <PlanningEvent
                                    event={event}
                                    events_colors={events_colors}
                                    pack_short_dict={pack_short_dict}
                                    highligtedEvent={highligtedEvent}
                                    height={height}
                                    simplified_view={simplified_view}
                                  ></PlanningEvent>
                                </EventModal>
                              </div>
                            );
                          })}
                      </div>{" "}
                    </div>
                  ))}
              </div>{" "}
            </div>
          ))}
    </>
  );
};
